import { useMemo } from "react";
import { Tag } from "../models/tag";
import { tagsApi } from "../services/tags";
import { FilterOption } from "./useTagData";
import { useWorkspaceCategories } from "./useWorkspaceCategories";

export const useCategoriesData = (selectedTagCategories?: Record<string, string[]>, filterOption?: FilterOption) => {
  const { workspaceCategories, isLoadingCategories } = useWorkspaceCategories(filterOption);
  const { data: serverTags = [], isLoading: isLoadingTags } = tagsApi.useGetTagsQuery();
  const tagCategories = useMemo(() => {
    let tagCategories: Record<string, Tag[]> = {};
    if (selectedTagCategories) {
      tagCategories = workspaceCategories.reduce(
        (acc, { name }) => {
          acc[name] = serverTags.filter((tag) => selectedTagCategories[name]?.includes(tag.tagId));
          return acc;
        },
        {} as Record<string, Tag[]>
      );
    } else {
      workspaceCategories.forEach((category) => {
        tagCategories[category.name] = serverTags.filter((tag) => tag.tagCategoryId === category.tagCategoryId);
      });
    }
    return tagCategories;
  }, [workspaceCategories, serverTags, selectedTagCategories]);

  return {
    tagCategories,
    categories: workspaceCategories,
    isLoadingCategories: isLoadingCategories || isLoadingTags,
  };
};
